import UtilServices from "@services/UtilServices";
import "./Input.scss";
import ButtonIcon from "@components/buttonIcon/ButtonIcon";

export default function Input(props) {
  let inputClassName = `input-input ${props.className} theme${props.theme}  
  ${props.disabled ? "disabled" : ""}`;

  const onReturn = (value) => {
    if (props.register !== null) {
      props.onChange(value);
      return props.setValue(props.name, value);
    }
    return props.onChange(value);
  };

  const handleMask = (e) => {
    //Mascaras
    if (props.mask === "telefone") {
      e = UtilServices.maskPhone(e);
    } else if (props.mask === "CPF") {
      e = UtilServices.maskCPF(e);
    } else if (props.mask === "CNPJ") {
      e = UtilServices.maskCNPJ(e);
    } else if (props.mask === "Date") {
      e = UtilServices.maskDate(e);
    } else if (props.mask === "CCM") {
      e = UtilServices.maskCCM(e);
    } else if (props.mask === "Valores") {
      e = UtilServices.maskCurrency(e);
    } else if (props.mask === "CNAE") {
      e = UtilServices.maskCNAE(e);
    } else if (props.mask === "CEP") {
      e = UtilServices.maskCEP(e);
    } else if (props.mask === "Porcentagem") {
      e = UtilServices.maskPercentage(e);
    } else if (props.mask === "mesAno") {
      e = UtilServices.maskMonthYear(e);
    } else if (props.mask === "RG") {
      e = UtilServices.maskRG(e);
    }

    return e;
  };

  const handleChange = (e) => {
    let input = e.target.value;

    if (props.type === "number") {
      // Remove todos os caracteres que nao sao numeros
      input = input?.replace(/[^0-9]/g, "");
    }
    if (props.type === "phone") {
      // Remove todos os caracteres que nao sao numeros
      input = input?.replace(/[^0-9+]/g, "");
    }
    if (props.type === "document") {
      // Remove todos os caracteres que sao numeros
      input = input?.replace(/[0-9]/g, "");
    }
    if (props.type === "login") {
      // Remove todos os caracteres e espaços
      input = input?.replace(/[^a-zA-Z0-9]/g, "");
    }
    if (props.type === "password") {
      // Remove todos os espaços
      input = input?.replace(/\s+/g, "");
    }
    if (props.type === "nomesobrenome") {
      // Remove todos os numeros e caracteres especiais.
      input = input?.replace(/[^A-Za-zÀ-Öà-öçÇıİĞğÜüŞş\s]/g, "");
    }
    if (props.type === "cpfemail") {
      // Remove apenas espaços
      input = input?.replace(/\s+/g, "");

      // Remove pontos e traços antes de validar como número
      // input = input.replace(/[.\-\/]/g, ""); // Remove . - /
    }

    return onReturn(handleMask(input));
  };

  return (
    <>
      <div className={`input ${props.className} theme${props.theme}`}>
        <div style={{ display: "flex" }}>
          {props.title && <p>{props.title}</p>}
          {props.tooltip && (
            <p
              data-tooltip-id={props.tooltipId}
              data-tooltip-content={props.tooltipDescricao}
              className="tooltipInput"
              style={{ color: props.tooltipIconColor, cursor: "pointer" }}
            >
              {props.tooltipIcon}
            </p>
          )}
        </div>
        {props.icon && (
          <div className="input-icon">
            {UtilServices.stringToJsx(props.icon)}
          </div>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: props.gapButton ? props.gapButton : "10px",
          }}
        >
          <input
            {...(props.register && {
              ...props.register(props.name, {
                ...props.registerProps,
              }),
            })}
            {...(props.maxLength !== null && {
              maxLength: props.maxLength,
            })}
            id={props.id}
            className={inputClassName}
            type={
              props.type === "number" ||
              props.type === "document" ||
              props.type === "date"
                ? "text"
                : props.type
            }
            onChange={handleChange}
            placeholder={props.placeholder}
            disabled={props.disabled}
            style={props.style}
            defaultValue={props.defaultValue}
            {...(props.register === null && {
              name: props.name,
              value: props.value,
            })}
          />
          {props?.button && (
            <ButtonIcon
              {...{
                //Tipo de botão
                [props.iconButton]: true,
                // title
                [`title${
                  props.iconButton.charAt(0).toUpperCase() +
                  props.iconButton.slice(1)
                }`]: props.titleButton,
                // on
                [`on${
                  props.iconButton.charAt(0).toUpperCase() +
                  props.iconButton.slice(1)
                }`]: props.onClickButton,
                //type
                [`type${
                  props.iconButton.charAt(0).toUpperCase() +
                  props.iconButton.slice(1)
                }`]: props.typeButton,
                //disabled
                [`disabled${
                  props.iconButton.charAt(0).toUpperCase() +
                  props.iconButton.slice(1)
                }`]: props.disabled,
              }}
            />
          )}
        </div>
      </div>
      {props.required && props.errors && props.errors[props.name] && (
        <span className="inputMsgError">
          {props.errors[props.name].message}
        </span>
      )}
    </>
  );
}

Input.defaultProps = {
  id: "",
  changeId: false,
  type: "text",
  placeholder: "",
  value: "",
  disabled: false,
  title: "",
  onChange: () => null,
  className: "",
  theme: "1",
  style: {},
  marginOnTop: false,
  mask: "",
  maxLength: null,
  defaultValue: "",
  icon: "",
  name: "", //Item para campo obrigatorio
  register: null, //Item para campo obrigatorio
  errors: null, //Item para campo obrigatorio
  required: true, //Item para campo obrigatorio
  setValue: null, //Item para campo obrigatorio
  //Button
  button: false,
  iconButton: "pesquisar",
  titleButton: "",
  typeButton: "button",
  onClickButton: () => null,
  gapButton: "10px",
  //ToolTip
  tooltip: false,
  tooltipId: "",
  tooltipIcon: <i className="fa-solid fa-hexagon-exclamation"></i>,
  tooltipDescricao: "",
  tooltipIconColor: "#ff7575c9",
};
